var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mkt-warning",class:( _obj = {}, _obj[_vm.txClass] = true, _obj['mkt-warning--small'] =  _vm.blSmall, _obj['mkt-warning--no-padding'] =  _vm.blNoPadding, _obj )},[_c('mkt-icon',{attrs:{"tx-icon":"icon-info","tx-icon-color":"#F58220","tx-font-size":"26px"}}),_vm._v(" "),_c('p',{staticClass:"mkt-warning__text"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }